module.exports = {
  version: '268',
  commitSha: '7a03d713ddecc8017ba5e9074d0c5e96c25b4dde',
  server: 'undefined',
  environment: 'test',
};
